<template>
  <el-main id="main">
    <div id="map">
      <head-menu
        class="headmenu"
        :regionType="range"
        :regionId="cityId"
        :regionGeom="regiongeometry"
        v-on:getHeadRegioncode="getgeo"
        v-on:getHeadspdata="getpdata"
        v-on:drowp="drowp"
        v-on:drowd="drowd"
        v-on:cleardrow="cleardrow"
        v-on:getQueryType="getQueryType"
        v-on:getRange="getRange"
      ></head-menu>
      <right-menu
        :prodata="cartdata"
        :tcprodata="tcdata"
        :checkAll="checkAll"
        v-on:sendclearall="sendclearall"
        v-on:sendclearalltc="sendclearalltc"
        class="rightmenu"
        v-show="$route.path !== '/subscriptionData'"
      >
      </right-menu>
      <left-list
        ref="leftList"
        :map="map"
        :prodata="$route.path === '/remoteSenseData'? rsdata : productdata"
        :cartdata="cartdata"
        :tcdata="tcdata"
        :queryType="queryType"
        :range="range"
        :regionname="regionname"
        :regiongeometry="regiongeometry"
        :cityId="cityId"
        v-on:getcartlists="getcartlist"
        v-on:gettclists="gettucenglist"
        class="leftlist"
        v-show="$route.path !== '/subscriptionData'"
      ></left-list>
    </div>
  </el-main>
</template>

<script>
import HeadMenu from '../components/HeadMenu/HeadMenu'
import RightMenu from '../components/RightMenu/RightMenu'
import LeftList from '../components/LeftMenu/LeftList'
import Map from '../common/map/Tmap.js'
import store from '../vuex/index.js'
export default {
  name: 'mainindex',
  components: {
    HeadMenu,
    RightMenu,
    LeftList
  },
  data () {
    return {
      map: null,
      maptype: 'img_c',
      productdata: {},
      rsdata: {},
      sddate: {},
      productcontent: [],
      cartdata: [],
      tcdata: [],
      user: {
        userId: '',
        userName: '',
        nickName: ''
      },
      queryType: '',
      range: '',
      regionname: '',
      regiongeometry: null,
      cityId: '',
      checkAll: false
    }
  },
  created () {
    // 加载购物车列表
    this.initCartInfos()
  },
  computed: {
    drawgeometry() {
      return store.state.drawgeometry
    }
  },
  mounted () {
    this.map = Map.getmap()
    Map.SwitchLayer(this.maptype)
    Map.InitMap(this.map)

    // 首页头部样式
    document.getElementById('head').style.position = 'absolute'
    // 首页尾部样式
    document.getElementById('footer').style.position = 'absolute'
  },
  destroyed() {
    this.cleardrow()
  },
  methods: {
    getcartlist (varl) {
      console.log(varl)
      this.cartdata = varl
    },
    gettucenglist (varl) {
      console.log(varl)
      this.tcdata = varl
    },
    sendclearall (val) {
      console.log('map')
      console.log(val)
      this.cartdata = val
    },
    sendclearalltc (val) {
      console.log(val)
      this.tcdata = val
    },
    getpdata (val) {
      if (this.$route.path === '/remoteSenseData') {
        this.rsdata = val
      } else if (this.$route.path === '/subscriptionData') {
        this.sddate = val
      } else {
        this.productdata = val
      }
      document.getElementById('fooderdata').innerHTML = val.productstartdate + ' 至 ' + val.productenddate
    },
    // 监听用户选择区域的方式：查询类型(1:行政区划,2:自定义,3:上传文件)
    getQueryType (val) {
      this.queryType = val
    },
    getRange (val) {
      this.range = val
    },
    cleardrow () {
      Map.ClearOverSource()
      this.regiongeometry = null
    },
    drowp () {
      Map.AddInteractions('rectangle', this.map, this.$route.path === '/remoteSenseData')
      this.getQueryType('2')
      localStorage.setItem('queryType', '2')
      this.getRange('custom')
    },
    drowd () {
      Map.AddInteractions('polygon', this.map, this.$route.path === '/remoteSenseData')
      this.getQueryType('2')
      localStorage.setItem('queryType', '2')
      this.getRange('custom')
    },
    testbutton () {
      Map.GetDrawPolygonWKT()
    },
    changemap (el) {
      Map.SwitchLayer(el)
    },
    getgeo (msg) {
      var josndatas = {
        type: msg.type,
        code: msg.code
      }
      this.sapost('/dmc/manage/standardProduct/regionGeometry', josndatas, r => {
        console.log(r)
        if (this.$route.path === '/subscriptionData') {
          Map.subAddWKT2Source(r.data[0].regiongeometry, true)
        } else {
          Map.AddWKT2Source(r.data[0].regiongeometry, true)
        }
        this.queryType = '1'
        localStorage.setItem('queryType', '1')
        this.range = msg.type
        this.regionname = msg.name
        this.cityId = r.data[0].gid
        this.regiongeometry = r.data[0].regiongeometry
        // this.$set(this.rsdata, 'regiongeometry', r.data[0].regiongeometry)
      })
    },
    initCartInfos () {
      // 校验用户是否登录
      // 已登录查询购物车接口
      if (sessionStorage.getItem('user')) {
        this.user = JSON.parse(sessionStorage.getItem('user'))
        var cartQueryData = {
          'customerid': this.user.userId,
          'carttype': this.$route.path === '/remoteSenseData' ? '0' : '1',
          'op': 'query',
          'product_geometry_json': [1]
        }
        this.sapost('/dmc/cart/cartoperation', cartQueryData, r => {
          let result = r.data
          if (result !== 'null') {
            this.cartdata = result
            let selectedArr = []
            this.cartdata.forEach((cart, index) => {
              if (cart.is_selected) {
                selectedArr.push(cart)
              }
            })
            if (selectedArr.length === this.cartdata.length && this.cartdata.length > 0) {
              this.checkAll = true
            }
          }
        })
      } else {
        // 未登录查询购物车参数
        let queryCartData = {
          'op': 'querycart',
          // 数据类型(0遥感数据1遥感产品2站点数据)
          'carttype': this.$route.path === '/remoteSenseData' ? '0' : '1'
        }
        // 未登录查询购物车接口
        var _this = this
        var selectedArr = []
        _this.sapost('/dmc/cart/session', queryCartData, r => {
          let message = r.data.message
          if (message !== 'null') {
            _this.cartdata = JSON.parse(message)
            _this.cartdata.forEach((cart, index) => {
              if (cart.is_selected) {
                selectedArr.push(cart)
              }
            })
            console.log(typeof selectedArr)
            if (selectedArr === undefined && selectedArr.length === _this.cartdata.length) {
              _this.checkAll = true
            }
          }
        })
      }
    }
  },
  watch: {
    $route(val) {
      this.initCartInfos()
      this.cleardrow()
      Map.changeMapCenter(this.map)
      this.tcdata.forEach(item => {
        if (val.path === '/remoteSenseData' || val.path === '/subscriptionData') {
          var name = 'Layer' + item.product_id
          Map.RemoveLayerByName(name)
        } else {
          // this.$refs.leftList.addtu(item)
        }
      })
    },
    drawgeometry(val) {
      this.regiongeometry = val
    }
  }
}
</script>

<style>
.map {
  display: block;
  width: 100%;
}
#map {
  height: 100%;
}
.ol-attribution,
.ol-zoom {
  display: none;
}
.headmenu {
  position: absolute;
  float: left;
  z-index: 99;
  margin-top: 70px;
}
.leftlist {
  position: absolute;
  z-index: 97;
  height: 70%;
  padding-top: 135px;
}
.rightmenu {
  position: absolute;
  z-index: 97;
  right: 0px;
  width: 362px;
  margin-top: 135px;
  overflow: hidden;
  height: 70%;
}
.ol-zoom {
  top: 5.5em;
  right: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/page/Main.vue